<router-outlet></router-outlet>
<p-dialog
        [(visible)]="showIdleDialog"
        [modal]="true"
        [style]="{ width: '450px' }"
        [header]="dialogHeader"
>
    <div class="flex align-items-center justify-content-center">
        <i aria-hidden="true"
                class="pi pi-exclamation-triangle mr-3 dt-dialog-ico"
        ></i>
        <span>{{ 'Verrai disconnesso tra' | translate }}  {{secondi}} {{ 'secondi' | translate }}</span>
    </div>

    <ng-template pTemplate="footer">
        <button
                (click)="logout('click logout dialog', 0, 0, 0)"
                class="p-button-text"
                icon="pi pi-sign-out"
                label="{{ 'Esci' | translate }}"
                pButton
                pRipple
        ></button>
        <button
                (click)="extend()"
                class="p-button-text"
                icon="pi pi-check"
                label="{{ 'Rimani connesso' | translate }}"
                pButton
                pRipple
        ></button>
    </ng-template>
</p-dialog>
